import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignCenter } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';
import { MenuItem } from '@chakra-ui/react';

export const CenterAlignButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().setTextAlign('center').run()}
         isDisabled={editor.isActive({ textAlign: 'center' })}
         icon={<FontAwesomeIcon icon={faAlignCenter} size="lg" />}
         title={_js('Center Align')}
         iconSpacing={0}
      ></MenuItem>
   );
};
